var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Wystąpił błąd przy dodawaniu promocji")]),_vm._l((_vm.promotionErrors),function(promotionError){return _c('p',{key:promotionError,staticClass:"error"},[_vm._v("\n    "+_vm._s(promotionError)+"\n  ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }